export const renderReportSectionTitle = (key: string): string => {
    let tmpTitle = '';
    switch (key) {
        case 'nodes-report':
            tmpTitle = 'Montant H.T. par lot';
            break;
        case 'nodes-by-location-report':
            tmpTitle = 'Montant H.T. par localisation';
            break;
        case 'nodes-by-category-and-location-report':
            tmpTitle = 'Montant H.T. par catégorie et localisation';
            break;
        case 'classification-report':
            tmpTitle = 'Montant H.T. par classification';
            break;
        default:
            break;
    }
    return tmpTitle;
};
